<template>
  <div class="hints" :class="{ 'view-only': viewOnly }">
    <label for="add-hint" v-if="!viewOnly">Hints/Notes</label>
    <div v-for="(hint, index) in hints" :key="hint" class="hint">
      <span>{{hint}}</span>
      <button
        type="button"
        class="hint-remove"
        @click="onRemove(index)"
        v-if="!viewOnly"
      >
        <ag-icon width="16" height="16">
          <x-icon />
        </ag-icon>
      </button>
    </div>
    <ag-form-group
      id="add-hint"
      label=""
      v-if="!viewOnly"
    >
      <div class="input-btn-combo">
        <input
          id="add-hint"
          class="input"
          type="text"
          v-model="newHint"
          autocomplete="off"
          @keypress.enter="submitHint"
          placeholder="Add new hint/note"
        />
        <button class="add-hint-btn" type="button" @click="submitHint">+ Add</button>
      </div>
    </ag-form-group>
  </div>
</template>

<script>
  import XIcon from "../../../components/icons/XIcon";

  export default {
    name: "Hints",
    props: {
      hints: {
        type: Array,
        default: () => ([])
      },
      viewOnly: {
        type: Boolean,
        default: false
      }
    },
    data: () => ({
      newHint: ''
    }),
    methods: {
      submitHint($event) {
        $event.preventDefault();
        if (this.newHint === '' || !this.newHint || this.hints.includes(this.newHint)) { return true }
        this.$emit("enter", this.newHint);
        this.newHint = null;
      },
      onRemove(index) {
        this.$emit("remove", index);
      }
    },
    components: { XIcon }
  };
</script>

<style scoped lang="scss">
  .hints {
    &.view-only {
      margin-top: $gutter;

      .hint:last-child {
        margin-bottom: 0;
      }
    }

    btn {
      min-width: 80px;
    }

    .hint {
      display: flex;
      line-height: 1.1em;
      border-radius: $radius;
      background: rgba($color-secondary, 0.05);
      border: 1px solid rgba($color-secondary, 0.2);
      box-shadow: 0 4px 22px rgba(0,0,0,0.05);
      margin: 0 0 $gutter 0;

      > span {
        padding: 12px $gutter;
        flex-grow: 1;
      }

      .hint-remove {
        padding: 12px;
        border: 0;
        border-left: 1px solid $color-gray-medium;
        background: transparent;
        min-width: 0;
        border-radius: 0;
        box-shadow: none;

        svg {
          fill: $color-gray;
          display: block;
        }

        &:hover {
          background: rgba($color-secondary,0.03);

          svg {
            fill: $color-secondary;
          }
        }
      }
    }

    .add-hint-btn {
      min-width: 80px;
    }
  }

  .input-btn-combo {
    display: flex;
    align-items: center;

    input {
      margin-right: $gutter;
      flex-grow: 1;
    }
  }

  label {
    font-weight: $font-semibold;
    padding-bottom: 5px;
  }

</style>
